'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useRef } from 'react'
import { makeQueryClient } from '@/lib/query-client'

export function QueryProvider({ children }: { children: ReactNode }) {
  const clientRef = useRef(makeQueryClient())
  return (
    <QueryClientProvider client={clientRef.current}>
      {children}
    </QueryClientProvider>
  )
}
